export const RECEIVE_PLANS = 'RECEIVE_PLANS';
export const GET_PLANS = 'GET_PLANS';
export const SET_PLAN = 'SET_PLAN';
export const UPDATE_PLAN = 'UPDATE_PLAN';
export const DELETE_PLAN = 'DELETE_PLAN';
export const FETCH_PLANS = 'FETCH_PLANS';
